module.exports = __webpack_public_path__ + "static/img/首页图片3.df57c01.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/首页图片3.jpg
// module id = ePwP
// module chunks = 1